import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/opt/render/project/src/layouts/default.vue").then(m => m.default || m))
}